import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Curious } from '@curi/react';

import './Press.css';
import PageHeader from '../../components/global/PageHeader';
import { gtmPageviewEvent } from '../../services/google-tag-manager';
const imgURL = process.env.REACT_APP_CLOUDFRONT_URL;

class Press extends React.PureComponent {
  componentDidMount() {
    gtmPageviewEvent({
      pageName: 'codespark.com: Press',
      componentProps: this.props,
    });
  }

  render() {
    return (
      <div className="press-page page">
        <Helmet>
          <title>Press | codeSpark</title>
          <meta name="description" content="Check out recent news and updates about codeSpark, the #1 learn-to-code app for kids ages 3-10." />
          <meta name="keywords" content="Kids coding languages, Hour of code, coding for kids, kids apps, kids games, learn to code, STEM, Reading, Math, Elementary school" />
          <meta property="og:title" content="Coding Game for Kids - Try it Free!" />
          <meta property="og:description" content="Try the #1 learn-to-code app for kids ages 3-10. Used by over 20 million kids worldwide, kids learn coding basics with puzzles and build skills to make their own games." />
          <meta name="twitter:card" content="app" />
          <meta name="twitter:site" content="@codesparkapp" />
          <meta name="twitter:description" content="Try the #1 learn-to-code app for kids ages 3-10. Used by over 20 million kids worldwide, kids learn coding basics with puzzles and build skills to make their own games." />
          <meta name="twitter:app:country" content="US" />
          <meta name="twitter:app:id:iphone" content="923441570" />
          <meta name="twitter:app:id:ipad" content="923441570" />
          <meta name="twitter:app:id:googleplay" content="org.codespark.thefoos" />
        </Helmet>
        <PageHeader text="Press" />
        <div className="grid-x grid-padding-x align-center">
          <div className="small-12 medium-9 large-8 cell page-subtitle">
            <p>
              We&rsquo;re making waves in the press and couldn&rsquo;t be more excited!
              For media inquiries, please contact <a href="mailto:info@codespark.com">info@codespark.com</a>.
            </p>
          </div>
        </div>
        <div className="grid-x grid-padding-x articles-wrapper">
          <div className="small-12 cell news-articles">
            <a href="https://finance.yahoo.com/video/increasingly-important-kids-understand-software-192636162.html" target="_blank" rel="noopener noreferrer">
              <div className="article">
                <div className="image-container">
                  <img src={`${imgURL}/flagship/press/logo_yahoo_finance.png`} alt="Yahoo Finance" />
                </div>
                <p>It&rsquo;s increasingly important that kids understand how software and coding works</p>
              </div>
            </a>
            <a href="https://edition.cnn.com/2018/02/22/health/kids-create-media-partner/index.html" target="_blank" rel="noopener noreferrer">
              <div className="article">
                <div className="image-container">
                  <img src={`${imgURL}/flagship/press/logo_cnn.png`} alt="CNN" />
                </div>
                <p>Tools to encourage kids&rsquo; creativity</p>
              </div>
            </a>
            <a href="http://www.npr.org/sections/ed/2015/09/18/441122285/learning-to-code-in-preschool" target="_blank" rel="noopener noreferrer">
              <div className="article">
                <div className="image-container">
                  <img src={`${imgURL}/flagship/press/logo_npr.png`} alt="npr" />
                </div>
                <p>Coding Class, Then Naptime: Computer Science For The Kindergarten Set</p>
              </div>
            </a>
            <a href="http://www.huffingtonpost.com/smart-parents/do-your-kids-need-to-lear_b_7473058.html" target="_blank" rel="noopener noreferrer">
              <div className="article">
                <div className="image-container">
                  <img src={`${imgURL}/flagship/press/logo_huff.png`} alt="Huffington Post" />
                </div>
                <p>Do Your Kids Need to Learn to Code? Yes! But Not for the Reasons You Think</p>
              </div>
            </a>
            <a href="https://www.washingtonpost.com/news/parenting/wp/2018/02/05/how-to-help-kids-create-media-not-just-consume-it/?utm_term=.1b0e9cbbccf9" target="_blank" rel="noopener noreferrer">
              <div className="article">
                <div className="image-container">
                  <img src={`${imgURL}/flagship/press/logo_washpost.png`} alt="The Washington Post" />
                </div>
                <p>The Foos: An app that lets kids create their own video game levels</p>
              </div>
            </a>
            <a href="http://www.usatoday.com/story/tech/columnist/gudmundsen/2015/09/27/how-get-kids-start-coding/72736670/" target="_blank" rel="noopener noreferrer">
              <div className="article">
                <div className="image-container">
                  <img src={`${imgURL}/flagship/press/logo_usa.png`} alt="USA Today" />
                </div>
                <p>How to get kids to start coding</p>
              </div>
            </a>
            <a href="https://techcrunch.com/2016/09/29/codespark-raises-4-1-million-for-games-that-teach-kids-how-to-code/" target="_blank" rel="noopener noreferrer">
              <div className="article">
                <div className="image-container">
                  <img src={`${imgURL}/flagship/press/logo_techcrunch.png`} alt="Tech Crunch" />
                </div>
                <p>codeSpark raises $4.1 million for games that teach kids how to code</p>
              </div>
            </a>
            <a href="https://www.commonsensemedia.org/blog/cool-tools-to-help-kids-learn-to-code" target="_blank" rel="noopener noreferrer">
              <div className="article">
                <div className="image-container">
                  <img src={`${imgURL}/flagship/press/logo_commonsense.png`} alt="Common Sense Media" />
                </div>
                <p>Cool Tools to Help Kids Learn to Code</p>
              </div>
            </a>
            <a href="http://www.gamesandlearning.org/2015/08/31/why-codespark-is-convinced-coding-for-kids-is-not-a-fad/" target="_blank" rel="noopener noreferrer">
              <div className="article">
                <div className="image-container">
                  <img src={`${imgURL}/flagship/press/logo_games_learning.png`} alt="Games and Learning" />
                </div>
                <p>Why codeSpark is Convinced Coding for Kids is Not a Fad</p>
              </div>
            </a>
            <a href="http://www.techwithkids.com/Review_SR01274S_the-foos-coding-5" target="_blank" rel="noopener noreferrer">
              <div className="article">
                <div className="image-container">
                  <img src={`${imgURL}/flagship/press/logo_tech_kids.png`} alt="Tech with Kids" />
                </div>
                <p>Tech with Kids gives THE FOOS 5 Stars!</p>
              </div>
            </a>
            <a href="https://medium.com/@gsvlabs/press-release-eleven-gsvlabs-edtech-startups-reimagine-the-future-of-education-936f4f47947c#.nlo1x3vm3" target="_blank" rel="noopener noreferrer">
              <div className="article">
                <div className="image-container">
                  <img src={`${imgURL}/flagship/press/logo_medium.png`} alt="Medium" />
                </div>
                <p>Press Release: Eleven GSVlabs EdTech startups reimagine the future of education</p>
              </div>
            </a>
            <a href={`${process.env.REACT_APP_BLOG_BASE_URL}/posts/the-foos-win-american-association-of-school-librarians-2016-best-apps-for-teaching-learning`} target="_blank" rel="noopener noreferrer">
              <div className="article">
                <div className="image-container">
                  <img src={`${imgURL}/flagship/press/logo_aasl.png`} alt="American Association of School Librarians" />
                </div>
                <p>The Foos win American Association of School Librarians&rsquo; 2016 Best App for Learning and Teaching!</p>
              </div>
            </a>
            <a href="https://tutora.co.uk/blog/60-best-educational-apps" target="_blank" rel="noopener noreferrer">
              <div className="article">
                <div className="image-container">
                  <img src={`${imgURL}/flagship/press/logo_tutorful.png`} alt="Tutorful" />
                </div>
                <p>60 Awesome Educational Apps You Need To Download Now</p>
              </div>
            </a>
            <a href="https://www.hostingadvice.com/blog/codespark-makes-tech-education-fun/" target="_blank" rel="noopener noreferrer">
              <div className="article">
                <div className="image-container">
                  <img src={`${imgURL}/flagship/press/logo_hosting_advice.png`} alt="Hosting Advice" />
                </div>
                <p>Making Tech Education Fun: codeSpark is Preparing More than 20M Kids for Success in a Tech-Driven Future</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

Press.contextTypes = {
  mixpanel: PropTypes.object
};

export default props => (
  <Curious>
    {({ router, response, navigation }) => {
      return <Press router={ router } response={ response } { ...props } />;
    }}
  </Curious>
);



// WEBPACK FOOTER //
// ./src/containers/Press/index.js